import { FC } from 'react';
import { logo_mindd } from '.';
const LogoIcon: FC<{ width?: number }> = ({ width = 24 }) => {
  return <img src={logo_mindd} width={width} alt="MINDD LOGO" />;
};

export default LogoIcon;
